export const ROLES = {
  BROKER: "broker",
  UNDERWRITER: "underwriter",
  ADMIN: "admin",
};

export default ROLES;
